module.exports = __webpack_public_path__ + "img/select-black.b8910906.svg";